import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#FDFBF7',
          padding: '2rem',
        }}>
          <div style={{ textAlign: 'center', maxWidth: '400px' }}>
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%',
              background: '#C2410C', margin: '0 auto 1.5rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '2rem',
            }}>
              &#128666;
            </div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1C1917', marginBottom: '0.5rem' }}>
              Algo salio mal
            </h1>
            <p style={{ color: '#57534E', marginBottom: '1.5rem' }}>
              Ha ocurrido un error inesperado. Por favor, recarga la pagina.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#C2410C', color: 'white', border: 'none',
                padding: '0.75rem 2rem', borderRadius: '9999px', cursor: 'pointer',
                fontSize: '1rem', fontWeight: '600',
              }}
            >
              Recargar pagina
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
